/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module IpamModule
 */

import {
    AviPermissionResource,
    ICustomIpamDnsProfile,
} from 'generated-types';

import {
    MessageItem,
    ObjectTypeItem,
    RepeatedMessageItem,
} from 'ajs/modules/data-model/factories';

import { withFullModalMixin } from 'ajs/js/utilities/mixins/with-full-modal.mixin';
import { CustomIpamDnsProfileModalComponent }
    from 'ng/modules/ipam/components/custom-ipam-dns-profile-modal';
import { L10nService } from '@vmw/ngx-vip';
import * as l10n from '../ipam.l10n';

interface ICustomDnsProfileData {
    config: ICustomIpamDnsProfile;
}

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description CustomIpamDnsProfile Item class.
 *
 * @author Aravindh Nagarajan
 */
export class CustomIpamDnsProfile extends withFullModalMixin(ObjectTypeItem) {
    public static ajsDependencies = [
        'l10nService',
    ];

    public data: ICustomDnsProfileData;
    public getConfig: () => ICustomIpamDnsProfile;
    private readonly l10nService: L10nService;

    constructor(args: {}) {
        const extendedArgs = {
            objectType: 'CustomIpamDnsProfile',
            windowElement: CustomIpamDnsProfileModalComponent,
            permissionName: AviPermissionResource.PERMISSION_CUSTOMIPAMDNSPROFILE,
            ...args,
        };

        super(extendedArgs);

        this.l10nService = this.getAjsDependency_('l10nService');
        this.l10nService.registerSourceBundles(dictionary);
    }

    /**
     * Getter for script_params.
     */
    public get scriptParams(): RepeatedMessageItem<MessageItem> {
        const { script_params: scriptParams } = this.config;

        return scriptParams as RepeatedMessageItem<MessageItem>;
    }

    /** @override */
    protected getModalBreadcrumbTitle(): string {
        return this.l10nService.getMessage(l10nKeys.customIpamDnsProfileModalBreadcrumbTitle);
    }
}

Object.assign(CustomIpamDnsProfile.prototype, {
    objectName: 'customipamdnsprofile',
});
